//@ts-nocheck
import React from 'react';
import { pages } from '../../config/pages';
import { Link } from 'react-router-dom';

const JapanMap: React.FC<{}> = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      // xmlns:xlink="http://www.w3.org/1999/xlink"
      width='585.201'
      height='538.063'
      viewBox='0 0 585.201 538.063'
      className='w-full'
    >
      <defs>
        <linearGradient
          id='linear-gradient'
          x1='0.5'
          x2='0.5'
          y2='1'
          gradientUnits='objectBoundingBox'
        >
          <stop offset='0' stop-color='#f29702' />
          <stop offset='1' stop-color='#ff7600' />
        </linearGradient>
        <filter
          id='長方形_31733'
          x='0.201'
          y='322.063'
          width='103'
          height='59'
          filterUnits='userSpaceOnUse'
        >
          <feOffset dy='3' input='SourceAlpha' />
          <feGaussianBlur stdDeviation='3' result='blur' />
          <feFlood flood-opacity='0.161' />
          <feComposite operator='in' in2='blur' />
          <feComposite in='SourceGraphic' />
        </filter>
        <filter
          id='長方形_31733-2'
          x='119.201'
          y='479.063'
          width='103'
          height='59'
          filterUnits='userSpaceOnUse'
        >
          <feOffset dy='3' input='SourceAlpha' />
          <feGaussianBlur stdDeviation='3' result='blur-2' />
          <feFlood flood-opacity='0.161' />
          <feComposite operator='in' in2='blur-2' />
          <feComposite in='SourceGraphic' />
        </filter>
        <filter
          id='長方形_31733-3'
          x='96.201'
          y='311.063'
          width='103'
          height='59'
          filterUnits='userSpaceOnUse'
        >
          <feOffset dy='3' input='SourceAlpha' />
          <feGaussianBlur stdDeviation='3' result='blur-3' />
          <feFlood flood-opacity='0.161' />
          <feComposite operator='in' in2='blur-3' />
          <feComposite in='SourceGraphic' />
        </filter>
        <filter
          id='長方形_31733-4'
          x='191.201'
          y='322.063'
          width='103'
          height='59'
          filterUnits='userSpaceOnUse'
        >
          <feOffset dy='3' input='SourceAlpha' />
          <feGaussianBlur stdDeviation='3' result='blur-4' />
          <feFlood flood-opacity='0.161' />
          <feComposite operator='in' in2='blur-4' />
          <feComposite in='SourceGraphic' />
        </filter>
        <filter
          id='長方形_31733-5'
          x='294.201'
          y='282.063'
          width='103'
          height='59'
          filterUnits='userSpaceOnUse'
        >
          <feOffset dy='3' input='SourceAlpha' />
          <feGaussianBlur stdDeviation='3' result='blur-5' />
          <feFlood flood-opacity='0.161' />
          <feComposite operator='in' in2='blur-5' />
          <feComposite in='SourceGraphic' />
        </filter>
        <filter
          id='長方形_31733-6'
          x='454.201'
          y='374.063'
          width='103'
          height='59'
          filterUnits='userSpaceOnUse'
        >
          <feOffset dy='3' input='SourceAlpha' />
          <feGaussianBlur stdDeviation='3' result='blur-6' />
          <feFlood flood-opacity='0.161' />
          <feComposite operator='in' in2='blur-6' />
          <feComposite in='SourceGraphic' />
        </filter>
        <filter
          id='長方形_31733-7'
          x='482.201'
          y='307.063'
          width='103'
          height='59'
          filterUnits='userSpaceOnUse'
        >
          <feOffset dy='3' input='SourceAlpha' />
          <feGaussianBlur stdDeviation='3' result='blur-7' />
          <feFlood flood-opacity='0.161' />
          <feComposite operator='in' in2='blur-7' />
          <feComposite in='SourceGraphic' />
        </filter>
        <filter
          id='長方形_31733-8'
          x='312.201'
          y='197.063'
          width='103'
          height='59'
          filterUnits='userSpaceOnUse'
        >
          <feOffset dy='3' input='SourceAlpha' />
          <feGaussianBlur stdDeviation='3' result='blur-8' />
          <feFlood flood-opacity='0.161' />
          <feComposite operator='in' in2='blur-8' />
          <feComposite in='SourceGraphic' />
        </filter>
        <filter
          id='長方形_31733-9'
          x='335.201'
          y='102.063'
          width='103'
          height='59'
          filterUnits='userSpaceOnUse'
        >
          <feOffset dy='3' input='SourceAlpha' />
          <feGaussianBlur stdDeviation='3' result='blur-9' />
          <feFlood flood-opacity='0.161' />
          <feComposite operator='in' in2='blur-9' />
          <feComposite in='SourceGraphic' />
        </filter>
        <filter
          id='長方形_31733-10'
          x='330.201'
          y='437.063'
          width='103'
          height='59'
          filterUnits='userSpaceOnUse'
        >
          <feOffset dy='3' input='SourceAlpha' />
          <feGaussianBlur stdDeviation='3' result='blur-10' />
          <feFlood flood-opacity='0.161' />
          <feComposite operator='in' in2='blur-10' />
          <feComposite in='SourceGraphic' />
        </filter>
        <filter
          id='長方形_31733-11'
          x='432.201'
          y='251.063'
          width='103'
          height='59'
          filterUnits='userSpaceOnUse'
        >
          <feOffset dy='3' input='SourceAlpha' />
          <feGaussianBlur stdDeviation='3' result='blur-11' />
          <feFlood flood-opacity='0.161' />
          <feComposite operator='in' in2='blur-11' />
          <feComposite in='SourceGraphic' />
        </filter>
        <filter
          id='長方形_31733-12'
          x='317.201'
          y='350.063'
          width='103'
          height='59'
          filterUnits='userSpaceOnUse'
        >
          <feOffset dy='3' input='SourceAlpha' />
          <feGaussianBlur stdDeviation='3' result='blur-12' />
          <feFlood flood-opacity='0.161' />
          <feComposite operator='in' in2='blur-12' />
          <feComposite in='SourceGraphic' />
        </filter>
      </defs>
      <g
        id='グループ_42531'
        data-name='グループ 42531'
        transform='translate(-915.899 -137.468)'
      >
        <g
          id='グループ_41306'
          data-name='グループ 41306'
          transform='translate(36 -4.328)'
        >
          <text
            id='様々なご要望に_柔軟にお応えできる_個性豊かなホール'
            data-name='様々なご要望に
柔軟にお応えできる
個性豊かなホール'
            transform='translate(1029 207)'
            fill='#333'
            font-size='22'
            font-family='NotoSerifJP-Bold, Noto Serif JP'
            font-weight='700'
          >
            <tspan x='-77' y='0'>
              様々
            </tspan>
            <tspan y='0'>なご</tspan>
            <tspan y='0'>要望</tspan>
            <tspan y='0'>に</tspan>
            <tspan x='-99' y='33'>
              柔軟
            </tspan>
            <tspan y='33'>にお</tspan>
            <tspan y='33'>応</tspan>
            <tspan y='33'>えできる</tspan>
            <tspan x='-87.78' y='66'>
              個性豊
            </tspan>
            <tspan y='66'>かなホール</tspan>
          </text>
          <text
            id='都道府県からご希望のホールを_お探しいただけます_'
            data-name='都道府県からご希望のホールを
お探しいただけます。'
            transform='translate(1034 325)'
            fill='#333'
            font-size='16'
            font-family='NotoSansJP-Regular, Noto Sans JP'
            letter-spacing='0.02em'
          >
            <tspan x='-114.08' y='0'>
              都道府県
            </tspan>
            <tspan y='0'>からご</tspan>
            <tspan y='0'>希望</tspan>
            <tspan y='0'>のホールを</tspan>
            <tspan x='-80.64' y='24'>
              お
            </tspan>
            <tspan y='24'>探</tspan>
            <tspan y='24'>しいただけます。</tspan>
          </text>
          <g
            id='グループ_40372'
            data-name='グループ 40372'
            transform='translate(900 141.796)'
          >
            <g id='グループ_40373' data-name='グループ 40373'>
              <path
                id='パス_68666'
                data-name='パス 68666'
                d='M129.788,0a24.092,24.092,0,0,0-24.065,24.065.992.992,0,1,0,1.985,0,22.085,22.085,0,0,1,44.17,0,.992.992,0,1,0,1.985,0A24.1,24.1,0,0,0,129.788,0'
                transform='translate(-0.808)'
                fill='#9f8a43'
              />
              <path
                id='パス_68667'
                data-name='パス 68667'
                d='M105.908,23.665H.992a.992.992,0,1,0,0,1.985H105.908a.992.992,0,0,0,0-1.985'
                transform='translate(0 -0.181)'
                fill='#9f8a43'
              />
              <path
                id='パス_68668'
                data-name='パス 68668'
                d='M258.171,23.665H153.255a.992.992,0,1,0,0,1.985H258.171a.992.992,0,1,0,0-1.985'
                transform='translate(-1.163 -0.181)'
                fill='#9f8a43'
              />
              <path
                id='パス_68669'
                data-name='パス 68669'
                d='M257.008,193.682H.992a.992.992,0,0,0,0,1.985H257.008a.992.992,0,1,0,0-1.985'
                transform='translate(0 -42.235)'
                fill='#9f8a43'
              />
              <path
                id='パス_68670'
                data-name='パス 68670'
                d='M105.908,20.665H.992a.992.992,0,0,0,0,1.985H105.908a.992.992,0,0,0,0-1.985'
                transform='translate(0 -0.158)'
                fill='#9f8a43'
              />
              <path
                id='パス_68671'
                data-name='パス 68671'
                d='M258.171,20.665H153.255a.992.992,0,1,0,0,1.985H258.171a.992.992,0,1,0,0-1.985'
                transform='translate(-1.163 -0.158)'
                fill='#9f8a43'
              />
            </g>
            <g
              id='グループ_41456'
              data-name='グループ 41456'
              transform='translate(118.93 9.079)'
            >
              <g
                id='グループ_40376'
                data-name='グループ 40376'
                transform='translate(0 0)'
              >
                <path
                  id='パス_68672'
                  data-name='パス 68672'
                  d='M9.043,1A8.048,8.048,0,0,0,3.353,14.738,8.048,8.048,0,1,0,14.734,3.357,8,8,0,0,0,9.043,1Z'
                  transform='translate(-1 -1)'
                  fill='none'
                  stroke='#9f8a43'
                  stroke-miterlimit='10'
                  stroke-width='3'
                />
                <line
                  id='線_56'
                  data-name='線 56'
                  x2='6.906'
                  y2='6.906'
                  transform='translate(13.805 13.867)'
                  fill='none'
                  stroke='#9f8a43'
                  stroke-linecap='round'
                  stroke-miterlimit='10'
                  stroke-width='3'
                />
              </g>
            </g>
          </g>
        </g>
        <g id='グループ_42530' data-name='グループ 42530'>
          <g id='グループ_42528' data-name='グループ 42528'>
            <g id='MAP' transform='translate(191.951 -959.359)'>
              <g id='japan' transform='translate(723.948 1096.829)'>
                <g
                  id='グループ_38520'
                  data-name='グループ 38520'
                  transform='translate(0 0)'
                >
                  <path
                    id='パス_68598'
                    data-name='パス 68598'
                    d='M66.016,383.843h-7.9a4.7,4.7,0,0,1-4.691-4.691V359.279H50.981v16.6a4.7,4.7,0,0,1-4.691,4.691h-14.8a4.7,4.7,0,0,1-4.691-4.691v-40.6a4.66,4.66,0,0,1,1.373-3.316l8.648-8.651V304.98l-6.694-6.7h-.442v2.69a4.7,4.7,0,0,1,4.171,4.662v9.46a4.7,4.7,0,0,1-4.691,4.691H13.054a4.661,4.661,0,0,1-3.317-1.374L1.374,310.05A4.661,4.661,0,0,1,0,306.733v-28.18a4.7,4.7,0,0,1,4.691-4.691H23.049l13.243-13.244a4.661,4.661,0,0,1,3.317-1.374H73.44a4.661,4.661,0,0,1,3.317,1.374l13.18,13.18v-22.69a8.59,8.59,0,0,1,8.58-8.58h16.349l8.826-8.826a8.526,8.526,0,0,1,6.067-2.513H229.1a8.524,8.524,0,0,1,6.067,2.513l5.264,5.264L249.389,230v-7.778a8.525,8.525,0,0,1,2.512-6.066l27.97-27.985V168a8.524,8.524,0,0,1,2.513-6.067l10.295-10.3a8.526,8.526,0,0,1,6.067-2.513h15.817a7.177,7.177,0,0,1,7.169,7.169v2.649a7.122,7.122,0,0,1-2.1,5.069L307.5,176.145v9.5h6.505l8.192-8.192a8.525,8.525,0,0,1,6.067-2.513h11.1l44.366-44.366V85.294l-3.218-3.218A8.524,8.524,0,0,1,378,76.009V73.055a8.524,8.524,0,0,1,2.512-6.067l3.219-3.218V46.955a8.524,8.524,0,0,1,2.513-6.067L398.6,28.534V18.7a7.329,7.329,0,0,1,7.32-7.32h10.13a7.329,7.329,0,0,1,7.32,7.32v8.984h11.345V20.757h-4.191a7.073,7.073,0,0,1-7.065-7.065V7.065A7.073,7.073,0,0,1,430.521,0h12.93a8.524,8.524,0,0,1,6.067,2.513l7.694,7.694a8.524,8.524,0,0,1,2.513,6.067V34.893l12.456,12.456a8.524,8.524,0,0,1,2.513,6.067v67.607a8.524,8.524,0,0,1-2.513,6.067l-5.26,5.26v85.658l10.749,10.749a8.525,8.525,0,0,1,2.513,6.067v31.44a8.526,8.526,0,0,1-2.513,6.067l-22.005,22a8.524,8.524,0,0,1-6.067,2.513h-2.134a6.454,6.454,0,0,1-6.446-6.446V270.255a8.525,8.525,0,0,1,2.513-6.067l6.067-6.067-1.06-1.06-10.3,10.3V277.3a7.839,7.839,0,0,1-7.83,7.831H411.125v12.422a8.522,8.522,0,0,1-2.514,6.067l-7.786,7.786a8.525,8.525,0,0,1-6.067,2.513h-4.428a8.58,8.58,0,0,1-8.58-8.581l0-19.634h-2.978l-11.157,11.157a8.525,8.525,0,0,1-6.067,2.513H321.031a8.59,8.59,0,0,1-8.58-8.58v-4.968h-5.875v13.753l7.549,7.548a8.526,8.526,0,0,1,2.513,6.067v7.255a7.474,7.474,0,0,1-7.465,7.465H297.465L277.5,347.889a8.523,8.523,0,0,1-6.067,2.513h-8.517a8.523,8.523,0,0,1-6.067-2.513l-15.725-15.725a8.525,8.525,0,0,1-2.513-6.067V299.132a8.524,8.524,0,0,1,2.513-6.067l4.718-4.718-4.187-4.187h-5.014l1.305,1.3a4.7,4.7,0,0,1,0,6.634l-.977.977a4.694,4.694,0,0,1-.5,6.049l-8.239,8.239a4.67,4.67,0,0,1-3.326,1.374h-.021a4.722,4.722,0,0,1-3.334-1.422l-5.985-6.158a4.71,4.71,0,0,1,.047-6.586l10.412-10.412H207.9l-7.7,7.7a8.519,8.519,0,0,1-4.744,2.412h10.121a4.661,4.661,0,0,1,3.317,1.374l16.54,16.54a4.66,4.66,0,0,1,1.374,3.317v14.235a4.66,4.66,0,0,1-1.374,3.317l-27.405,27.405a4.7,4.7,0,0,1-6.634,0L174.036,343.1H162.513l-13.207,13.207v5.346a4.7,4.7,0,0,1-4.691,4.691H130a4.661,4.661,0,0,1-3.317-1.374L113.7,352.028a4.661,4.661,0,0,1-1.374-3.318l0-28.479a4.66,4.66,0,0,1,1.374-3.316l23.6-23.6a4.656,4.656,0,0,1,2.811-1.347,8.715,8.715,0,0,1-.737-.658l-2.954-2.987H131.8l-3.538,3.538a8.525,8.525,0,0,1-6.067,2.513h-1.2a8.523,8.523,0,0,1-6.067-2.513l-7.4-7.4h-6.932l1.382,1.382a4.66,4.66,0,0,1,1.374,3.317v29.956a4.661,4.661,0,0,1-1.374,3.317L90.44,333.964v25.464a4.66,4.66,0,0,1-1.375,3.318L69.333,382.47a4.66,4.66,0,0,1-3.316,1.373m92.438-76.058h15.353l12.142-12.142a4.66,4.66,0,0,1,2.343-1.273H146.038a8.726,8.726,0,0,1-1.065-.065Z'
                    transform='translate(0 130.417)'
                    fill='#bdbebf'
                  />
                  <path
                    id='パス_68599'
                    data-name='パス 68599'
                    d='M9.224,31.269a4.66,4.66,0,0,1-3.317-1.374L2.793,26.781a4.7,4.7,0,0,1-.173-6.452L1.369,19.077a4.7,4.7,0,0,1,0-6.632L12.445,1.372a4.7,4.7,0,0,1,6.634,0l3.277,3.277a4.7,4.7,0,0,1,.109,6.521l1.083,1.083a4.7,4.7,0,0,1,0,6.634L12.54,29.9a4.66,4.66,0,0,1-3.317,1.374'
                    transform='translate(333.143 251.986)'
                    fill='#bdbebf'
                  />
                  <path
                    id='パス_68601'
                    data-name='パス 68601'
                    d='M64.861,381.532h-7.9A3.536,3.536,0,0,1,53.428,378V356.968H48.67v17.751a3.536,3.536,0,0,1-3.536,3.536h-14.8a3.535,3.535,0,0,1-3.536-3.536v-40.6a3.536,3.536,0,0,1,1.035-2.5l8.987-8.989V303.346l-7.371-7.373H27.373v4.972h.635a3.536,3.536,0,0,1,3.536,3.536v9.459a3.536,3.536,0,0,1-3.536,3.536H11.9a3.535,3.535,0,0,1-2.5-1.036l-8.363-8.363A3.536,3.536,0,0,1,0,305.578V277.4a3.536,3.536,0,0,1,3.536-3.536H22.373l13.581-13.581a3.536,3.536,0,0,1,2.5-1.036h33.83a3.536,3.536,0,0,1,2.5,1.036l15.19,15.19a7.478,7.478,0,0,1-.037-.749V249.954a7.433,7.433,0,0,1,7.425-7.425h16.681a.351.351,0,0,0,.25-.1l9.06-9.06a7.376,7.376,0,0,1,5.25-2.175h99.342a7.376,7.376,0,0,1,5.25,2.175l5.831,5.831a.354.354,0,0,0,.5,0l9.76-9.766a.357.357,0,0,0,.1-.25v-8.11a7.375,7.375,0,0,1,2.173-5.249l28.2-28.22a.351.351,0,0,0,.1-.25v-20.5a7.375,7.375,0,0,1,2.175-5.25L292.34,151.3a7.376,7.376,0,0,1,5.25-2.175h15.817a6.02,6.02,0,0,1,6.013,6.013v2.65a5.975,5.975,0,0,1-1.761,4.252L305.3,174.407a.356.356,0,0,0-.1.25v10.637a.354.354,0,0,0,.354.353h7.64a.351.351,0,0,0,.25-.1l8.427-8.427a7.378,7.378,0,0,1,5.25-2.175H338.54a.353.353,0,0,0,.251-.1L383.626,130a.351.351,0,0,0,.1-.25V83.807a.351.351,0,0,0-.1-.25L380.173,80.1A7.377,7.377,0,0,1,378,74.854V71.9a7.377,7.377,0,0,1,2.175-5.25l3.453-3.453a.351.351,0,0,0,.1-.25V45.8a7.376,7.376,0,0,1,2.174-5.25L398.494,27.96a.351.351,0,0,0,.1-.25V17.54a6.172,6.172,0,0,1,6.165-6.165h10.13a6.172,6.172,0,0,1,6.165,6.165v9.786a.354.354,0,0,0,.354.353h12.948a.354.354,0,0,0,.354-.353V18.8a.354.354,0,0,0-.354-.353h-4.993a5.917,5.917,0,0,1-5.91-5.91V5.91A5.917,5.917,0,0,1,429.366,0H442.3a7.376,7.376,0,0,1,5.25,2.175l7.694,7.694a7.377,7.377,0,0,1,2.174,5.25V34.07a.351.351,0,0,0,.1.25l12.691,12.691a7.375,7.375,0,0,1,2.175,5.25v67.607a7.376,7.376,0,0,1-2.175,5.25l-5.495,5.495a.351.351,0,0,0-.1.25v86.322a.358.358,0,0,0,.1.25L475.7,228.419a7.378,7.378,0,0,1,2.174,5.25v31.44a7.378,7.378,0,0,1-2.174,5.25l-22,22a7.376,7.376,0,0,1-5.25,2.175H446.31a5.3,5.3,0,0,1-5.291-5.291V269.1a7.376,7.376,0,0,1,2.175-5.25l6.634-6.634a.354.354,0,0,0,0-.5l-2.194-2.194a.354.354,0,0,0-.5,0l-11.105,11.105a.355.355,0,0,0-.1.25v10.273a6.683,6.683,0,0,1-6.675,6.675H409.168a.354.354,0,0,0-.353.354V296.4a7.374,7.374,0,0,1-2.175,5.25l-7.786,7.786a7.377,7.377,0,0,1-5.25,2.175h-4.427a7.424,7.424,0,0,1-7.425-7.426l0-20.436a.353.353,0,0,0-.353-.353h-4.113a.357.357,0,0,0-.25.1l-11.392,11.392a7.376,7.376,0,0,1-5.25,2.175H319.876a7.433,7.433,0,0,1-7.425-7.425v-5.77a.354.354,0,0,0-.353-.353h-7.479a.354.354,0,0,0-.354.353v14.887a.351.351,0,0,0,.1.25l7.784,7.784a7.377,7.377,0,0,1,2.174,5.25V319.3a6.317,6.317,0,0,1-6.309,6.31h-12.04a.351.351,0,0,0-.249.1l-20.2,20.2a7.376,7.376,0,0,1-5.25,2.175h-8.517a7.376,7.376,0,0,1-5.25-2.175l-15.725-15.725a7.376,7.376,0,0,1-2.174-5.25V297.977a7.375,7.375,0,0,1,2.174-5.25l5.285-5.285a.354.354,0,0,0,0-.5l-4.989-4.989a.35.35,0,0,0-.25-.1h-8.136l3.278,3.277a3.536,3.536,0,0,1,0,5l-1.75,1.749.275.276a3.535,3.535,0,0,1,0,5l-8.24,8.239a3.536,3.536,0,0,1-5.036-.036l-5.984-6.158a3.536,3.536,0,0,1,.035-4.964l12.384-12.384H206.409a.351.351,0,0,0-.25.1l-7.932,7.932a7.377,7.377,0,0,1-5.25,2.175H144.883a7.377,7.377,0,0,1-5.25-2.174l-3.773-3.773a.352.352,0,0,0-.25-.1h-5.3a.356.356,0,0,0-.25.1l-3.773,3.773a7.377,7.377,0,0,1-5.25,2.175h-1.2a7.377,7.377,0,0,1-5.25-2.174l-7.636-7.636a.352.352,0,0,0-.25-.1H97.362q-.379,0-.749-.038L100,285.5a3.535,3.535,0,0,1,1.036,2.5v29.956a3.535,3.535,0,0,1-1.036,2.5L88.13,332.33v25.942a3.536,3.536,0,0,1-1.036,2.5L67.361,380.5a3.536,3.536,0,0,1-2.5,1.035'
                    transform='translate(0.366 131.341)'
                    fill='#fff'
                  />
                  <path
                    id='パス_68602'
                    data-name='パス 68602'
                    d='M30.546,71.545H15.927a3.535,3.535,0,0,1-2.5-1.036L1.036,58.119A3.536,3.536,0,0,1,0,55.618L0,27.139a3.535,3.535,0,0,1,1.036-2.5l23.6-23.6a3.535,3.535,0,0,1,5,0L43.906,15.3H61.351L73.831,2.816a3.536,3.536,0,0,1,2.5-1.036H91.507a3.536,3.536,0,0,1,2.5,1.036l16.54,16.54a3.537,3.537,0,0,1,1.036,2.5V36.092a3.536,3.536,0,0,1-1.036,2.5L83.142,66a3.536,3.536,0,0,1-5,0l-17.7-17.7H47.964L34.081,62.184V68.01a3.536,3.536,0,0,1-3.535,3.536'
                    transform='translate(112.664 423.214)'
                    fill='#fff'
                  />
                  <path
                    id='パス_68603'
                    data-name='パス 68603'
                    d='M8.071,28.96a3.524,3.524,0,0,1-2.5-1.036L2.457,24.811a3.536,3.536,0,0,1,0-5l.639-.639L1.034,17.107a3.535,3.535,0,0,1,0-5L12.109,1.036a3.536,3.536,0,0,1,5,0l3.277,3.277a3.536,3.536,0,0,1,0,5l-.706.706,1.9,1.9a3.535,3.535,0,0,1,0,5L10.571,27.925a3.523,3.523,0,0,1-2.5,1.036'
                    transform='translate(333.508 252.908)'
                    fill='#fff'
                  />
                  <path
                    id='パス_68606'
                    data-name='パス 68606'
                    d='M0,.9v9.853a.9.9,0,0,0,.9.9H33.389a1.573,1.573,0,0,1,1.112.461l4.387,4.387a.9.9,0,0,0,1.276,0l2.7-2.7a.9.9,0,0,0,.264-.638V.9a.9.9,0,0,0-.9-.9H.9A.9.9,0,0,0,0,.9'
                    transform='translate(398.362 373.332)'
                    fill='#6cbcbe'
                  />
                  <path
                    id='パス_68607'
                    data-name='パス 68607'
                    d='M54.6,16.6a1.669,1.669,0,0,0-.489-1.18L46.645,7.956,39.31.62a2.117,2.117,0,0,0-1.5-.62H14.054a1.014,1.014,0,0,0-.717.3L.3,13.337a1.013,1.013,0,0,0-.3.716v6.83A1.013,1.013,0,0,0,1.013,21.9H53.588A1.013,1.013,0,0,0,54.6,20.884Z'
                    transform='translate(386.883 350.095)'
                    fill='#6cbcbe'
                  />
                  <path
                    id='パス_68608'
                    data-name='パス 68608'
                    d='M29.9,36.01a1.3,1.3,0,0,0,1.3-1.3V1.329A1.329,1.329,0,0,0,29.867,0H1.328A1.328,1.328,0,0,0,0,1.329v18.01A2.065,2.065,0,0,0,.605,20.8L15.339,35.534a1.629,1.629,0,0,0,1.151.477Z'
                    transform='translate(410.313 312.745)'
                    fill='#6cbcbe'
                  />
                  <path
                    id='パス_68609'
                    data-name='パス 68609'
                    d='M22.58,0a1.42,1.42,0,0,0-1,.415L5.96,16.032c-.014.014-.034.02-.05.033L.416,21.559a1.419,1.419,0,0,0,0,2.007L20.7,43.851a1.419,1.419,0,0,0,2.007,0L34.841,31.717a2.089,2.089,0,0,1,1.477-.612H58.49a.51.51,0,0,0,.361-.871L44.657,16.043a.67.67,0,0,1-.2-.474V1.419A1.419,1.419,0,0,0,43.042,0Z'
                    transform='translate(364.509 317.649)'
                    fill='#6cbcbe'
                  />
                  <path
                    id='パス_68610'
                    data-name='パス 68610'
                    d='M11.81,22.717,2.538,31.989A1.507,1.507,0,0,0,2.1,33.055V54.708a1.236,1.236,0,0,0,1.236,1.236H6.706a2.149,2.149,0,0,0,1.52-.629L31.308,32.233a1.951,1.951,0,0,0,.571-1.379V.957A.957.957,0,0,0,30.923,0H.957A.957.957,0,0,0,0,.957v16.8a.571.571,0,0,0,.975.4l3.106-3.106a1.2,1.2,0,0,1,1.69,0L11.81,21.1a1.146,1.146,0,0,1,0,1.621'
                    transform='translate(442.824 366.4)'
                    fill='#6cbcbe'
                  />
                  <path
                    id='パス_68611'
                    data-name='パス 68611'
                    d='M45.743,47.411H14.681a1.213,1.213,0,0,1-.857-.355l-1.837-1.837L.164,33.4a.557.557,0,0,1,.394-.95H12.989a1.605,1.605,0,0,0,1.605-1.605V1.5A1.5,1.5,0,0,1,16.1,0H31.639a1.55,1.55,0,0,1,1.55,1.549v31.3a2.493,2.493,0,0,0,.731,1.764l12.03,12.03c.277.272.173.771-.207.771'
                    transform='translate(428.253 317.649)'
                    fill='#6cbcbe'
                  />
                  <path
                    id='パス_68612'
                    data-name='パス 68612'
                    d='M1.1,0A1.1,1.1,0,0,0,0,1.1V22.5a1.1,1.1,0,0,0,1.1,1.1H8.953c.009,0,.016,0,.024,0L33.3,23.62a1.1,1.1,0,0,0,1.1-1.1V9.732a1.1,1.1,0,0,1,.322-.777L37.8,5.871a1.1,1.1,0,0,0,0-1.555L33.807.322A1.1,1.1,0,0,0,33.029,0Z'
                    transform='translate(398.362 386.33)'
                    fill='#6cbcbe'
                  />
                  <g
                    id='グループ_38517'
                    data-name='グループ 38517'
                    transform='translate(390.179 0)'
                  >
                    <path
                      id='パス_68600'
                      data-name='パス 68600'
                      d='M13.954,136.636a6.294,6.294,0,0,1-4.479-1.855l-7.619-7.619a6.335,6.335,0,0,1,0-8.959l6.324-6.324L7.956,87.9a7.055,7.055,0,0,1,7.054-7.12H27.66L37.991,70.451,38,57.613a7.007,7.007,0,0,1,2.066-4.985L44.489,48.2V7.054A7.062,7.062,0,0,1,51.544,0H65.862A7.007,7.007,0,0,1,70.85,2.067l51.622,51.622H151.78a6.556,6.556,0,0,1,6.549,6.549v3.647a6.5,6.5,0,0,1-1.919,4.631l-3.034,3.034V91.528l3.046,3.046a6.47,6.47,0,0,1,1.907,4.6v1.957a6.519,6.519,0,0,1-6.511,6.512H129.568l-26.3,26.307a7.008,7.008,0,0,1-4.988,2.067H93.024a7.008,7.008,0,0,1-4.988-2.065l-23.792-23.79-6.007,6.007a7.054,7.054,0,0,1-9.976,0l-7.494-7.494-7.8-.046v.49a7,7,0,0,1,4.626,2.057l5.568,5.568a5.985,5.985,0,0,1,1.765,4.261v1.47a6.025,6.025,0,0,1-6.118,6.025l-13.888-.209-6.487,6.487a6.294,6.294,0,0,1-4.479,1.856'
                      transform='translate(0 0)'
                      fill='#bdbebf'
                    />
                    <path
                      id='パス_68604'
                      data-name='パス 68604'
                      d='M12.8,134.326a5.146,5.146,0,0,1-3.663-1.517l-7.619-7.619a5.179,5.179,0,0,1,0-7.325L8.184,111.2,7.957,86.737a5.9,5.9,0,0,1,5.9-5.953H26.983L37.991,69.775,38,56.459a5.859,5.859,0,0,1,1.727-4.168l4.765-4.765V5.9a5.905,5.905,0,0,1,5.9-5.9H64.707a5.86,5.86,0,0,1,4.171,1.728l51.961,51.961h29.785a5.4,5.4,0,0,1,5.394,5.393v3.647a5.358,5.358,0,0,1-1.58,3.814l-3.373,3.373V90.851l3.384,3.384a5.32,5.32,0,0,1,1.569,3.787V99.98a5.362,5.362,0,0,1-5.356,5.356H127.934L101.3,131.981a5.86,5.86,0,0,1-4.171,1.728H91.869a5.861,5.861,0,0,1-4.17-1.727L63.089,107.375,56.265,114.2a5.9,5.9,0,0,1-8.342,0l-7.83-7.83-9.436-.055v2.8h.794a5.861,5.861,0,0,1,4.171,1.727l5.568,5.568a4.838,4.838,0,0,1,1.426,3.444v1.47a4.87,4.87,0,0,1-4.943,4.87l-14.38-.216-6.832,6.833a5.146,5.146,0,0,1-3.663,1.517'
                      transform='translate(0.52 0.616)'
                      fill='#fff'
                    />
                    <path
                      id='パス_68613'
                      data-name='パス 68613'
                      d='M148.845,59.18v-3.6a1.89,1.89,0,0,0-1.89-1.89H116.519a1.889,1.889,0,0,1-1.336-.554L63.1,1.057A3.608,3.608,0,0,0,60.554,0H46.593a2.206,2.206,0,0,0-2.206,2.206V44.671a1.89,1.89,0,0,1-.553,1.336l-5.385,5.385a1.891,1.891,0,0,0-.554,1.336l-.006,14.193a1.89,1.89,0,0,1-.554,1.335L25.363,80.23a1.89,1.89,0,0,1-1.336.554H10.152a2.3,2.3,0,0,0-2.3,2.32l.234,25.216a1.889,1.889,0,0,1-.553,1.354L.553,116.655a1.89,1.89,0,0,0,0,2.673L7.825,126.6a1.89,1.89,0,0,0,2.673,0l7.151-7.151a1.89,1.89,0,0,1,1.365-.553l14.512.218a1.89,1.89,0,0,0,1.918-1.89v-.676a1.889,1.889,0,0,0-.554-1.336l-5.544-5.544a1.889,1.889,0,0,0-1.336-.553H25.374a1.89,1.89,0,0,1-1.89-1.89v-6.1a1.89,1.89,0,0,1,1.9-1.89l11.767.069a1.891,1.891,0,0,1,1.325.554L47.12,108.5a1.89,1.89,0,0,0,2.673,0l8.323-8.322a1.89,1.89,0,0,1,2.672,0L86.5,125.884a2.572,2.572,0,0,0,1.819.754H93.4a2.573,2.573,0,0,0,1.82-.754l27.059-27.066a1.891,1.891,0,0,1,1.337-.554h23.34a1.89,1.89,0,0,0,1.89-1.89V94.516a1.89,1.89,0,0,0-.553-1.336l-3.846-3.846A1.888,1.888,0,0,1,143.892,88V65.7a1.888,1.888,0,0,1,.554-1.336l3.846-3.846a1.89,1.89,0,0,0,.553-1.336'
                      transform='translate(4.158 4.152)'
                      fill='#6cbcbe'
                    />
                  </g>
                  <path
                    id='パス_68614'
                    data-name='パス 68614'
                    d='M74.559,36.351V1.212A1.212,1.212,0,0,0,73.346,0H42.119a1.346,1.346,0,0,0-1.347,1.346V8.138a1.047,1.047,0,0,1-1.047,1.047h-28.3a2.114,2.114,0,0,0-1.284.532L.395,19.462A1.659,1.659,0,0,0,0,20.563V36.615a1.216,1.216,0,0,0,1.216,1.216H21.1a.989.989,0,0,0,.989-.989V34.266a1.458,1.458,0,0,1,1.342-1.34h31.2a1.18,1.18,0,0,1,1.34,1.34V36.5A1.332,1.332,0,0,0,57.3,37.831H73.079a1.48,1.48,0,0,0,1.48-1.48'
                    transform='translate(386.884 278.478)'
                    fill='#6cbcbe'
                  />
                  <path
                    id='パス_68615'
                    data-name='パス 68615'
                    d='M10.316,23.306V43.753a1.664,1.664,0,0,0,1.664,1.664H37.02a1.664,1.664,0,0,0,1.664-1.664V36.9l0-35.238A1.664,1.664,0,0,0,37.016,0H1.664A1.664,1.664,0,0,0,0,1.664V19.307a1.664,1.664,0,0,0,1.664,1.664H7.982a2.334,2.334,0,0,1,2.334,2.334'
                    transform='translate(387.633 240.906)'
                    fill='#6cbcbe'
                  />
                  <path
                    id='パス_68616'
                    data-name='パス 68616'
                    d='M44.415,12.473V1.573A1.573,1.573,0,0,0,42.842,0H7.3A1.573,1.573,0,0,0,5.731,1.573V12.614a1.573,1.573,0,0,1-.461,1.112L.461,18.536A1.572,1.572,0,0,0,0,19.648v4.872a1.573,1.573,0,0,0,.461,1.112l4.809,4.81a1.572,1.572,0,0,1,.461,1.112v23.8A1.573,1.573,0,0,0,7.3,56.932H42.838a1.573,1.573,0,0,0,1.573-1.573V52.272c0-.008,0-.014,0-.022Z'
                    transform='translate(381.9 182.633)'
                    fill='#6cbcbe'
                  />
                  <path
                    id='パス_68617'
                    data-name='パス 68617'
                    d='M14.867,13.206V24.8a2.371,2.371,0,0,1-.694,1.677L.64,40.013A2.186,2.186,0,0,0,0,41.558v3.479a1.379,1.379,0,0,0,1.379,1.379h36.6a2.042,2.042,0,0,1,2.042,2.042v9.024a.468.468,0,0,0,.8.331L52.049,46.587a.678.678,0,0,1,.48-.2H79.114a.722.722,0,0,0,.51-1.232L67.406,32.938a2.7,2.7,0,0,1-.792-1.913V11.051a2.606,2.606,0,0,0-.763-1.842L57.4.761A2.6,2.6,0,0,0,55.566,0H41.481a1.755,1.755,0,0,0-1.755,1.754V9.62a1.755,1.755,0,0,0,1.755,1.754h7.857a1.645,1.645,0,0,1,1.645,1.645V26.182a1.5,1.5,0,0,1-1.5,1.5H31.753a1.5,1.5,0,0,1-1.5-1.5V13.206a1.831,1.831,0,0,0-1.831-1.831H16.7a1.831,1.831,0,0,0-1.831,1.831'
                    transform='translate(387.632 134.878)'
                    fill='#6cbcbe'
                  />
                  <path
                    id='パス_68618'
                    data-name='パス 68618'
                    d='M12.246.536.536,12.242A1.831,1.831,0,0,0,0,13.537V49.8a1.831,1.831,0,0,0,1.831,1.831h37.9A1.831,1.831,0,0,0,41.559,49.8V1.831A1.832,1.832,0,0,0,39.727,0H13.54a1.831,1.831,0,0,0-1.295.536'
                    transform='translate(427.656 182.605)'
                    fill='#6cbcbe'
                  />
                  <path
                    id='パス_68619'
                    data-name='パス 68619'
                    d='M0,4.661V39.888a1.675,1.675,0,0,0,1.675,1.675H32.111a1.675,1.675,0,0,0,1.675-1.675V25.712a1.675,1.675,0,0,1,.491-1.184l6.792-6.792a1.675,1.675,0,0,0,.491-1.184V1.675A1.675,1.675,0,0,0,39.884,0H1.675A1.675,1.675,0,0,0,0,1.675Z'
                    transform='translate(427.656 235.575)'
                    fill='#6cbcbe'
                  />
                  <path
                    id='パス_68620'
                    data-name='パス 68620'
                    d='M1.75,19.1l1.527,1.527a1.122,1.122,0,0,0,1.587,0l9.421-9.421a1.122,1.122,0,0,0,0-1.587L11.473,6.812a1.122,1.122,0,0,1,0-1.587l1.62-1.62a1.121,1.121,0,0,0,0-1.586L11.4.328a1.122,1.122,0,0,0-1.587,0L.329,9.816a1.122,1.122,0,0,0,0,1.586L3.3,14.38a1.122,1.122,0,0,1,0,1.586L1.75,17.517a1.122,1.122,0,0,0,0,1.587'
                    transform='translate(337.508 256.909)'
                    fill='#6cbcbe'
                  />
                  <path
                    id='パス_68621'
                    data-name='パス 68621'
                    d='M35.943,48.872h5.621A1.573,1.573,0,0,0,43.138,47.3V1.574A1.574,1.574,0,0,0,41.564,0H10.7A1.574,1.574,0,0,0,9.125,1.574v18a2.243,2.243,0,0,1-2.244,2.243H1.573A1.574,1.574,0,0,0,0,23.391V39.606a1.574,1.574,0,0,0,.461,1.112l7.614,7.615,0,0L20.7,60.959a1.574,1.574,0,0,0,2.225,0l11.431-11.43a2.242,2.242,0,0,1,1.586-.657'
                    transform='translate(281.155 341.587)'
                    fill='#6cbcbe'
                  />
                  <path
                    id='パス_68622'
                    data-name='パス 68622'
                    d='M37.2,20.012,59.5,42.307a1.41,1.41,0,0,1,.413,1v6.27a1.41,1.41,0,0,1-1.41,1.41H39.613a2.08,2.08,0,0,0-2.08,2.08V68.041a1.41,1.41,0,0,1-1.41,1.41H1.41A1.41,1.41,0,0,1,0,68.041V21.989a1.41,1.41,0,0,1,1.41-1.41H5.138a2.08,2.08,0,0,0,2.08-2.08V1.41A1.41,1.41,0,0,1,8.628,0h22a1.41,1.41,0,0,1,1,.413L42.41,11.194a1.41,1.41,0,0,1,0,1.994l-5.232,5.232a1.119,1.119,0,0,0,.024,1.593'
                    transform='translate(325.633 321.008)'
                    fill='#6cbcbe'
                  />
                  <path
                    id='パス_68623'
                    data-name='パス 68623'
                    d='M12.961,22.311a1.95,1.95,0,0,1,1.95-1.95H31.235a1.28,1.28,0,0,0,1.28-1.28V1.28A1.28,1.28,0,0,0,31.235,0H1.28A1.28,1.28,0,0,0,0,1.28V24.359a1.28,1.28,0,0,0,1.28,1.28h10.4a1.28,1.28,0,0,0,1.28-1.28Z'
                    transform='translate(364.506 373.332)'
                    fill='#6cbcbe'
                  />
                  <path
                    id='パス_68624'
                    data-name='パス 68624'
                    d='M34.518,19.405h8.074a1.088,1.088,0,0,1,1.088,1.088l0,25.754a1.373,1.373,0,0,0,1.373,1.373h7.431a2.711,2.711,0,0,0,1.917-.794l8.952-8.952a1.088,1.088,0,0,0,.319-.769V20.565a1.088,1.088,0,0,0-1.087-1.088l-6.471,0a1,1,0,0,1-1.065-1.035V4.322a1.088,1.088,0,0,0-1.088-1.088H37.919a1.088,1.088,0,0,0-1.088,1.088V6.755a1.758,1.758,0,0,1-1.758,1.758H22.949a1.758,1.758,0,0,1-1.758-1.758V1.088A1.088,1.088,0,0,0,20.1,0H1.088A1.088,1.088,0,0,0,0,1.088v30.9a1.088,1.088,0,0,0,1.088,1.088H19.645a1.816,1.816,0,0,0,1.284-.532l12.82-12.82a1.089,1.089,0,0,1,.769-.318'
                    transform='translate(341.975 391.798)'
                    fill='#6cbcbe'
                  />
                  <path
                    id='パス_68625'
                    data-name='パス 68625'
                    d='M20.537,0H12.808a1.23,1.23,0,0,0-.87.36L.36,11.937a1.23,1.23,0,0,0,0,1.739l5.491,5.491a1.23,1.23,0,0,0,.87.36H10.7a1.229,1.229,0,0,1,1.23,1.23V31.846a1.23,1.23,0,0,0,1.23,1.23H34.979a1.23,1.23,0,0,0,1.23-1.23V1.23A1.23,1.23,0,0,0,34.979,0Z'
                    transform='translate(304.425 391.798)'
                    fill='#6cbcbe'
                  />
                  <path
                    id='パス_68626'
                    data-name='パス 68626'
                    d='M3.318,45.289a1.286,1.286,0,0,0,1.819,0L21.676,28.758a.67.67,0,0,1,.474-.2H46.63a1.286,1.286,0,0,0,1.286-1.286v-9.44a1.287,1.287,0,0,0-.377-.909L31,.377a1.286,1.286,0,0,0-1.819,0L12.643,16.922a1.286,1.286,0,0,0-.377.909V28.1a1.286,1.286,0,0,1-.376.909L.376,40.527a1.286,1.286,0,0,0,0,1.818Z'
                    transform='translate(241.024 333.502)'
                    fill='#6cbcbe'
                  />
                  <path
                    id='パス_68627'
                    data-name='パス 68627'
                    d='M40.053,31.337a1.177,1.177,0,0,0,1.177-1.177V2.086A1.177,1.177,0,0,0,40.053.909H36.075a1.177,1.177,0,0,0-.832.345L25.228,11.269a1.178,1.178,0,0,1-.832.345l-11.475,0a1.177,1.177,0,0,1-1.177-1.177V1.177A1.177,1.177,0,0,0,10.566,0H1.177A1.177,1.177,0,0,0,0,1.177V30.16a1.177,1.177,0,0,0,1.177,1.177H40.053Z'
                    transform='translate(290.28 308.91)'
                    fill='#6cbcbe'
                  />
                  <path
                    id='パス_68628'
                    data-name='パス 68628'
                    d='M23.551,56.451a2.422,2.422,0,0,1,1.712.709L35.9,67.8a1.751,1.751,0,0,0,2.476,0L52.174,54a1.751,1.751,0,0,0,.513-1.238V35.2a1.705,1.705,0,0,1,.4-1.047L63.243,24.011a1.751,1.751,0,0,0,.514-1.239V1.751A1.751,1.751,0,0,0,62.006,0H54.994a1.751,1.751,0,0,0-1.238.513L8.18,46.089a1.752,1.752,0,0,1-1.238.512H1.751A1.751,1.751,0,0,0,0,48.352V54.7a1.751,1.751,0,0,0,1.751,1.75Z'
                    transform='translate(332.851 263.217)'
                    fill='#6cbcbe'
                  />
                  <path
                    id='パス_68629'
                    data-name='パス 68629'
                    d='M11.1,13.972V35.678a1.492,1.492,0,0,1-.437,1.055L.437,46.96a1.491,1.491,0,0,0,0,2.109l14.7,14.7a.661.661,0,0,0,1.129-.467V25.725a2.162,2.162,0,0,1,2.162-2.162h9.429a1.492,1.492,0,0,0,1.492-1.492V21a1.493,1.493,0,0,1,.437-1.055L42.89,6.837a2.333,2.333,0,0,0,.683-1.65V1.835A1.835,1.835,0,0,0,41.738,0H25.115a3.494,3.494,0,0,0-2.47,1.023l-10.56,10.56a3.377,3.377,0,0,0-.989,2.388'
                    transform='translate(272.678 284.008)'
                    fill='#6cbcbe'
                  />
                  <path
                    id='パス_68630'
                    data-name='パス 68630'
                    d='M0,1.672v29.2a1.672,1.672,0,0,0,1.672,1.672H14.157a1.652,1.652,0,0,1,1.168.484l9.039,9.039a1.337,1.337,0,0,0,.946.392h3.317a1.338,1.338,0,0,0,.946-.392l4.676-4.676a1.044,1.044,0,0,0,.305-.738V9.079a1.043,1.043,0,0,0-1.043-1.043H23.024a1.713,1.713,0,0,1-1.713-1.713V1.043A1.043,1.043,0,0,0,20.267,0H1.672A1.672,1.672,0,0,0,0,1.672'
                    transform='translate(93.84 377.406)'
                    fill='#6cbcbe'
                  />
                  <path
                    id='パス_68631'
                    data-name='パス 68631'
                    d='M0,16.806a1.229,1.229,0,0,0,1.229,1.229h34.7a1.229,1.229,0,0,0,1.229-1.229V1.228A1.229,1.229,0,0,0,35.928,0H9.1a1.228,1.228,0,0,0-.869.36L.36,8.235A1.228,1.228,0,0,0,0,9.1Z'
                    transform='translate(167.347 366.067)'
                    fill='#6cbcbe'
                  />
                  <path
                    id='パス_68632'
                    data-name='パス 68632'
                    d='M49.517,17.071V8.717A1.634,1.634,0,0,1,50,7.561L56.676.881A.516.516,0,0,0,56.312,0H12.063a2.882,2.882,0,0,0-2.037.844L.642,10.228A2.191,2.191,0,0,0,0,11.777v5.293a.964.964,0,0,0,.964.964H48.552a.964.964,0,0,0,.964-.964'
                    transform='translate(116.491 366.067)'
                    fill='#6cbcbe'
                  />
                  <path
                    id='パス_68633'
                    data-name='パス 68633'
                    d='M1.114,34.424H22.887a1.114,1.114,0,0,0,.787-.326l8.9-8.9a1.115,1.115,0,0,0,.326-.787V1.113A1.113,1.113,0,0,0,31.783,0H1.114A1.113,1.113,0,0,0,0,1.113v32.2a1.113,1.113,0,0,0,1.114,1.113'
                    transform='translate(171.607 385.442)'
                    fill='#6cbcbe'
                  />
                  <path
                    id='パス_68634'
                    data-name='パス 68634'
                    d='M36.945,0H1.331A1.331,1.331,0,0,0,0,1.331v25.71a1.331,1.331,0,0,0,1.331,1.331H7.305a1.33,1.33,0,0,1,.941.39l5.143,5.143a1.768,1.768,0,0,0,1.25.518H39.2a1.331,1.331,0,0,0,1.331-1.331V1.331A1.331,1.331,0,0,0,39.2,0Z'
                    transform='translate(129.731 385.442)'
                    fill='#6cbcbe'
                  />
                  <path
                    id='パス_68635'
                    data-name='パス 68635'
                    d='M37.451,26.182,30.8,19.526a1.814,1.814,0,0,1-.531-1.283V1.145A1.145,1.145,0,0,0,29.12,0H14.375a1.144,1.144,0,0,0-.81.335L.335,13.566a1.145,1.145,0,0,0,0,1.619L24.391,39.242a1.145,1.145,0,0,0,1.619,0L37.451,27.8a1.145,1.145,0,0,0,0-1.619'
                    transform='translate(249.551 363.405)'
                    fill='#6cbcbe'
                  />
                  <path
                    id='パス_68636'
                    data-name='パス 68636'
                    d='M11.288.294.294,11.288A1,1,0,0,0,.284,12.7L4.87,17.415a1,1,0,0,0,1.429.01l6.811-6.811a1,1,0,0,0,0-1.419L11.752,7.839a1,1,0,0,1,0-1.419L14.584,3.59a1,1,0,0,0,0-1.418L12.706.294a1,1,0,0,0-1.419,0'
                    transform='translate(218.545 416.088)'
                    fill='#6cbcbe'
                  />
                  <path
                    id='パス_68637'
                    data-name='パス 68637'
                    d='M16.709,30.511H28.982a1.7,1.7,0,0,1,1.2.5l9.041,9.041a1.025,1.025,0,0,0,.724.3H52.121a.643.643,0,0,0,.455-1.1L26.708,13.384a1.024,1.024,0,0,0-1.447,0l-1.678,1.673a.648.648,0,0,1-.7.151.651.651,0,0,1-.246-.152L9.053,1.475c-.011-.011-.017-.027-.028-.039L7.891.3A1.025,1.025,0,0,0,7.166,0H1.025A1.025,1.025,0,0,0,0,1.025V13.8a1.025,1.025,0,0,0,.3.724L15.984,30.211a1.024,1.024,0,0,0,.724.3'
                    transform='translate(222.141 366.067)'
                    fill='#6cbcbe'
                  />
                  <path
                    id='パス_68638'
                    data-name='パス 68638'
                    d='M.975,0A.975.975,0,0,0,0,.975V42.614a.975.975,0,0,0,.975.974H30.846a.975.975,0,0,0,.975-.974V32.047a.975.975,0,0,0-.285-.689l-16.1-16.1a1.644,1.644,0,0,1-.481-1.163V.975A.975.975,0,0,0,13.974,0Z'
                    transform='translate(205.842 366.067)'
                    fill='#6cbcbe'
                  />
                  <path
                    id='パス_68639'
                    data-name='パス 68639'
                    d='M29.959,40.805l8.824-8.824a.74.74,0,0,0,0-1.046l-8.8-8.811a.74.74,0,0,0-.524-.217H19.615a1.41,1.41,0,0,1-1.41-1.41V.74a.74.74,0,0,0-.74-.74H.74A.74.74,0,0,0,0,.74V22.712a.739.739,0,0,0,.217.523l17.57,17.57a.74.74,0,0,0,.523.217H29.435a.741.741,0,0,0,.523-.217'
                    transform='translate(242.511 434.874)'
                    fill='#6cbcbe'
                  />
                  <path
                    id='パス_68640'
                    data-name='パス 68640'
                    d='M18.961,38.547l.006-34.121a1.356,1.356,0,0,0-.4-.959L16.118,1.016,15.574.473A1.618,1.618,0,0,0,14.43,0H.941A.941.941,0,0,0,0,.941v45.8a.941.941,0,0,0,.941.942H9.828a.941.941,0,0,0,.666-.276l8.191-8.2a.941.941,0,0,0,.275-.665'
                    transform='translate(262.055 407.757)'
                    fill='#6cbcbe'
                  />
                  <path
                    id='パス_68641'
                    data-name='パス 68641'
                    d='M33.4,19.621a.614.614,0,0,0,.434-1.048l-5.2-5.2L15.517.257a.878.878,0,0,0-1.242,0L2.457,12.076a.878.878,0,0,0,0,1.242l2.659,2.658,3.022,3.017a2.558,2.558,0,0,1,.366.948L8.5,54.778a1.941,1.941,0,0,1-.615,1.382L.257,63.785a.878.878,0,0,0,0,1.241l8.026,8.03a.878.878,0,0,0,1.242,0L20.613,61.967a.878.878,0,0,1,.621-.257H36.118A1.177,1.177,0,0,0,37.3,60.533v-10.1a.878.878,0,0,0-.257-.621L27.49,40.265a.878.878,0,0,1-.257-.621V20.85a1.229,1.229,0,0,1,1.229-1.229Z'
                    transform='translate(273.864 391.706)'
                    fill='#6cbcbe'
                  />
                  <path
                    id='パス_68642'
                    data-name='パス 68642'
                    d='M4.408,35.616h16.4a.9.9,0,0,0,.9-.9V9.818a.9.9,0,0,0-.264-.637L12.532.264A.9.9,0,0,0,11.895,0H.9A.9.9,0,0,0,0,.9v9.935a.9.9,0,0,0,.9.9H3.43A.9.9,0,0,1,4.067,12l7.977,7.977a.9.9,0,0,1,0,1.274L3.771,29.526a.9.9,0,0,0-.264.637v4.553a.9.9,0,0,0,.9.9'
                    transform='translate(239.004 397.919)'
                    fill='#6cbcbe'
                  />
                  <path
                    id='パス_68643'
                    data-name='パス 68643'
                    d='M.114,10.111,13.98,23.977,14,24l.383.344a.577.577,0,0,0,.386.148H19.56a.578.578,0,0,0,.409-.169h0L33.164,11.126a.782.782,0,0,0,0-1.106L23.393.248a.849.849,0,0,0-1.2,0L13.16,9.281a.579.579,0,0,1-.409.169H.388a.387.387,0,0,0-.274.661'
                    transform='translate(11.213 399.288)'
                    fill='#6cbcbe'
                  />
                  <path
                    id='パス_68644'
                    data-name='パス 68644'
                    d='M5.9.343l-2.7,2.7a1.169,1.169,0,0,0,0,1.653L13.774,15.265a.669.669,0,0,1,0,.947L.342,29.644a1.169,1.169,0,0,0,0,1.653l6.51,6.512a1.169,1.169,0,0,0,1.653,0l6.669-6.67a1.839,1.839,0,0,1,1.3-.538h8.734a1.17,1.17,0,0,0,.827-.342L47.356,8.936a1.169,1.169,0,0,0,0-1.653L40.416.343A1.168,1.168,0,0,0,39.589,0H6.727A1.168,1.168,0,0,0,5.9.343'
                    transform='translate(32.579 394.122)'
                    fill='#6cbcbe'
                  />
                  <path
                    id='パス_68645'
                    data-name='パス 68645'
                    d='M.5,21.1H6.117A1.373,1.373,0,0,1,7.489,22.47V33.782a1.1,1.1,0,0,0,1.1,1.1H35.906a1.1,1.1,0,0,0,1.1-1.1V16.161a1.1,1.1,0,0,0-.321-.775L21.616.321a1.1,1.1,0,0,0-1.55,0L.147,20.246A.5.5,0,0,0,.5,21.1'
                    transform='translate(60.868 403.635)'
                    fill='#6cbcbe'
                  />
                  <path
                    id='パス_68646'
                    data-name='パス 68646'
                    d='M40.665,22.359,27.011,8.7,18.679.373a1.273,1.273,0,0,0-.9-.373H1.274A1.274,1.274,0,0,0,0,1.273V37.979a1.274,1.274,0,0,0,1.274,1.273H13.527A1.274,1.274,0,0,0,14.8,37.979V19.24a1.274,1.274,0,0,1,1.274-1.274h9.281A1.274,1.274,0,0,1,26.63,19.24V41.257A1.274,1.274,0,0,0,27.9,42.531H34a1.274,1.274,0,0,0,.9-.373L46.784,30.28a1.274,1.274,0,0,0,0-1.8Z'
                    transform='translate(30.701 466.808)'
                    fill='#6cbcbe'
                  />
                  <path
                    id='パス_68647'
                    data-name='パス 68647'
                    d='M20.021,15.152,5.15.281A.957.957,0,0,0,4.472,0H.958A.958.958,0,0,0,0,.958V27.783a.957.957,0,0,0,.281.677l7.8,7.8a.959.959,0,0,0,.678.281H23.514a.958.958,0,0,0,.958-.959V28.042a.958.958,0,0,0-.958-.958H21.26a.959.959,0,0,1-.958-.959V15.83a.958.958,0,0,0-.281-.678'
                    transform='translate(3.903 408.739)'
                    fill='#6cbcbe'
                  />
                  <path
                    id='パス_68648'
                    data-name='パス 68648'
                    d='M.859,39.4H17.324a1.784,1.784,0,0,1,1.261.522L25.9,47.233a1.115,1.115,0,0,0,1.575,0l7.719-7.719a1.114,1.114,0,0,0,.326-.788V1.114A1.114,1.114,0,0,0,34.406,0H17.817a1.112,1.112,0,0,0-.788.326L9.551,7.8a1.115,1.115,0,0,0-.326.788V28.9a1.116,1.116,0,0,1-.326.788L.372,38.22c-.647.647-.427,1.176.487,1.176'
                    transform='translate(31.498 426.072)'
                    fill='#6cbcbe'
                  />
                  <path
                    id='パス_68649'
                    data-name='パス 68649'
                    d='M37.077,0H9.913A1.174,1.174,0,0,0,8.739,1.174V25.2a1.844,1.844,0,0,1-.54,1.3L.344,34.356a1.174,1.174,0,0,0,0,1.661L12.718,48.391l6.166,6.165a1.175,1.175,0,0,0,1.661,0L25,50.106a1.175,1.175,0,0,0,.344-.831V22.841a1.174,1.174,0,0,1,.344-.83L37.908,9.789a1.175,1.175,0,0,0,.344-.831V1.174A1.174,1.174,0,0,0,37.077,0'
                    transform='translate(59.619 439.852)'
                    fill='#6cbcbe'
                  />
                  <path
                    id='パス_68650'
                    data-name='パス 68650'
                    d='M37.81,11.236,27.06.486A1.66,1.66,0,0,0,25.885,0h-13.8a1.661,1.661,0,0,0-1.175.486L.162,11.236a.55.55,0,0,0,.389.938h36.87a.55.55,0,0,0,.389-.938'
                    transform='translate(177.598 428.531)'
                    fill='#6cbcbe'
                  />
                  <path
                    id='パス_68651'
                    data-name='パス 68651'
                    d='M0,10.045a.639.639,0,0,0,.188.453L20.239,30.55a.918.918,0,0,0,1.3,0L34.354,17.732a1.606,1.606,0,0,0,.47-1.136V3.75a1.749,1.749,0,0,0-.512-1.237l-2-2A1.752,1.752,0,0,0,31.075,0H.838A.838.838,0,0,0,0,.838Z'
                    transform='translate(185.887 442.045)'
                    fill='#6cbcbe'
                  />
                  <path
                    id='パス_68652'
                    data-name='パス 68652'
                    d='M11.793,47.345a1.063,1.063,0,0,1,.311-.752L33.968,24.729a1.062,1.062,0,0,1,.752-.311h32.7a.928.928,0,0,0,.927-.928V15.575A1.075,1.075,0,0,0,67.271,14.5h-7.99l0,0H39.764a2.072,2.072,0,0,1-1.466-.607L24.965.562a1.919,1.919,0,0,0-2.714,0L.774,22.039A2.63,2.63,0,0,0,0,23.9L0,50.18a2.674,2.674,0,0,0,.783,1.892L10.975,62.264a.479.479,0,0,0,.817-.339Z'
                    transform='translate(116.202 427.545)'
                    fill='#6cbcbe'
                  />
                  <path
                    id='パス_68653'
                    data-name='パス 68653'
                    d='M0,22.127V36.895a1.026,1.026,0,0,0,1.026,1.026H12.85a1.026,1.026,0,0,0,1.027-1.026V31.057a1.028,1.028,0,0,1,.3-.726L29.531,14.978a1.027,1.027,0,0,1,.726-.3h14.56a1.026,1.026,0,0,1,.726.3L62.907,32.343a1.507,1.507,0,0,0,2.131,0l10.73-10.729a1.027,1.027,0,0,0,0-1.451L72.86,17.254,55.906.3a1.026,1.026,0,0,0-.726-.3H22.127A1.027,1.027,0,0,0,21.4.3L.3,21.4a1.026,1.026,0,0,0-.3.725'
                    transform='translate(129.334 453.302)'
                    fill='#6cbcbe'
                  />
                </g>
              </g>
              <g
                id='コンポーネント_367_50'
                data-name='コンポーネント 367 – 50'
                transform='translate(1141.124 1239.66)'
              >
                <path
                  id='パス_68574'
                  data-name='パス 68574'
                  d='M10.46,0a10.454,10.454,0,0,1,8.155,17L10.46,29.543,2.3,17A10.454,10.454,0,0,1,10.46,0'
                  transform='translate(0)'
                  stroke='#fff'
                  stroke-width='2'
                  fill='url(#linear-gradient)'
                />
                <path
                  id='パス_68575'
                  data-name='パス 68575'
                  d='M28.494,32.95a4.455,4.455,0,1,0-4.455-4.456,4.46,4.46,0,0,0,4.455,4.456'
                  transform='translate(-18.034 -18.035)'
                  fill='#fff'
                />
              </g>
              <g
                id='コンポーネント_367_51'
                data-name='コンポーネント 367 – 51'
                transform='translate(1122.009 1328.667)'
              >
                <path
                  id='パス_68574-2'
                  data-name='パス 68574'
                  d='M10.46,0a10.454,10.454,0,0,1,8.155,17L10.46,29.543,2.3,17A10.454,10.454,0,0,1,10.46,0'
                  transform='translate(0)'
                  stroke='#fff'
                  stroke-width='2'
                  fill='url(#linear-gradient)'
                />
                <path
                  id='パス_68575-2'
                  data-name='パス 68575'
                  d='M28.494,32.95a4.455,4.455,0,1,0-4.455-4.456,4.46,4.46,0,0,0,4.455,4.456'
                  transform='translate(-18.034 -18.035)'
                  fill='#fff'
                />
              </g>
              <g
                id='コンポーネント_367_52'
                data-name='コンポーネント 367 – 52'
                transform='translate(1166.38 1419.157)'
              >
                <path
                  id='パス_68574-3'
                  data-name='パス 68574'
                  d='M10.46,0a10.454,10.454,0,0,1,8.155,17L10.46,29.543,2.3,17A10.454,10.454,0,0,1,10.46,0'
                  transform='translate(0)'
                  stroke='#fff'
                  stroke-width='2'
                  fill='url(#linear-gradient)'
                />
                <path
                  id='パス_68575-3'
                  data-name='パス 68575'
                  d='M28.494,32.95a4.455,4.455,0,1,0-4.455-4.456,4.46,4.46,0,0,0,4.455,4.456'
                  transform='translate(-18.034 -18.035)'
                  fill='#fff'
                />
              </g>
              <g
                id='コンポーネント_367_53'
                data-name='コンポーネント 367 – 53'
                transform='translate(1146.901 1447.003)'
              >
                <path
                  id='パス_68574-4'
                  data-name='パス 68574'
                  d='M10.46,0a10.454,10.454,0,0,1,8.155,17L10.46,29.543,2.3,17A10.454,10.454,0,0,1,10.46,0'
                  transform='translate(0)'
                  stroke='#fff'
                  stroke-width='2'
                  fill='url(#linear-gradient)'
                />
                <path
                  id='パス_68575-4'
                  data-name='パス 68575'
                  d='M28.494,32.95a4.455,4.455,0,1,0-4.455-4.456,4.46,4.46,0,0,0,4.455,4.456'
                  transform='translate(-18.034 -18.035)'
                  fill='#fff'
                />
              </g>
              <g
                id='コンポーネント_367_54'
                data-name='コンポーネント 367 – 54'
                transform='translate(1103.241 1395.482)'
              >
                <path
                  id='パス_68574-5'
                  data-name='パス 68574'
                  d='M10.46,0a10.454,10.454,0,0,1,8.155,17L10.46,29.543,2.3,17A10.454,10.454,0,0,1,10.46,0'
                  transform='translate(0)'
                  stroke='#fff'
                  stroke-width='2'
                  fill='url(#linear-gradient)'
                />
                <path
                  id='パス_68575-5'
                  data-name='パス 68575'
                  d='M28.494,32.95a4.455,4.455,0,1,0-4.455-4.456,4.46,4.46,0,0,0,4.455,4.456'
                  transform='translate(-18.034 -18.035)'
                  fill='#fff'
                />
              </g>
              <g
                id='コンポーネント_367_55'
                data-name='コンポーネント 367 – 55'
                transform='translate(933.128 1468.204)'
              >
                <path
                  id='パス_68574-6'
                  data-name='パス 68574'
                  d='M10.46,0a10.454,10.454,0,0,1,8.155,17L10.46,29.543,2.3,17A10.454,10.454,0,0,1,10.46,0'
                  transform='translate(0)'
                  stroke='#fff'
                  stroke-width='2'
                  fill='url(#linear-gradient)'
                />
                <path
                  id='パス_68575-6'
                  data-name='パス 68575'
                  d='M28.494,32.95a4.455,4.455,0,1,0-4.455-4.456,4.46,4.46,0,0,0,4.455,4.456'
                  transform='translate(-18.034 -18.035)'
                  fill='#fff'
                />
              </g>
              <g
                id='コンポーネント_367_56'
                data-name='コンポーネント 367 – 56'
                transform='translate(861.87 1475.644)'
              >
                <path
                  id='パス_68574-7'
                  data-name='パス 68574'
                  d='M10.46,0a10.454,10.454,0,0,1,8.155,17L10.46,29.543,2.3,17A10.454,10.454,0,0,1,10.46,0'
                  transform='translate(0)'
                  stroke='#fff'
                  stroke-width='2'
                  fill='url(#linear-gradient)'
                />
                <path
                  id='パス_68575-7'
                  data-name='パス 68575'
                  d='M28.494,32.95a4.455,4.455,0,1,0-4.455-4.456,4.46,4.46,0,0,0,4.455,4.456'
                  transform='translate(-18.034 -18.035)'
                  fill='#fff'
                />
              </g>
              <g
                id='コンポーネント_367_57'
                data-name='コンポーネント 367 – 57'
                transform='translate(901.558 1472.036)'
              >
                <path
                  id='パス_68574-8'
                  data-name='パス 68574'
                  d='M10.46,0a10.454,10.454,0,0,1,8.155,17L10.46,29.543,2.3,17A10.454,10.454,0,0,1,10.46,0'
                  transform='translate(0)'
                  stroke='#fff'
                  stroke-width='2'
                  fill='url(#linear-gradient)'
                />
                <path
                  id='パス_68575-8'
                  data-name='パス 68575'
                  d='M28.494,32.95a4.455,4.455,0,1,0-4.455-4.456,4.46,4.46,0,0,0,4.455,4.456'
                  transform='translate(-18.034 -18.035)'
                  fill='#fff'
                />
              </g>
              <g
                id='コンポーネント_367_58'
                data-name='コンポーネント 367 – 58'
                transform='translate(844.744 1526.272)'
              >
                <path
                  id='パス_68574-9'
                  data-name='パス 68574'
                  d='M10.46,0a10.454,10.454,0,0,1,8.155,17L10.46,29.543,2.3,17A10.454,10.454,0,0,1,10.46,0'
                  transform='translate(0)'
                  stroke='#fff'
                  stroke-width='2'
                  fill='url(#linear-gradient)'
                />
                <path
                  id='パス_68575-9'
                  data-name='パス 68575'
                  d='M28.494,32.95a4.455,4.455,0,1,0-4.455-4.456,4.46,4.46,0,0,0,4.455,4.456'
                  transform='translate(-18.034 -18.035)'
                  fill='#fff'
                />
              </g>
              <g
                id='コンポーネント_367_59'
                data-name='コンポーネント 367 – 59'
                transform='translate(1072.035 1486.691)'
              >
                <path
                  id='パス_68574-10'
                  data-name='パス 68574'
                  d='M10.46,0a10.454,10.454,0,0,1,8.155,17L10.46,29.543,2.3,17A10.454,10.454,0,0,1,10.46,0'
                  transform='translate(0)'
                  stroke='#fff'
                  stroke-width='2'
                  fill='url(#linear-gradient)'
                />
                <path
                  id='パス_68575-10'
                  data-name='パス 68575'
                  d='M28.494,32.95a4.455,4.455,0,1,0-4.455-4.456,4.46,4.46,0,0,0,4.455,4.456'
                  transform='translate(-18.034 -18.035)'
                  fill='#fff'
                />
              </g>
              <g
                id='コンポーネント_367_60'
                data-name='コンポーネント 367 – 60'
                transform='translate(1122.547 1428.963)'
              >
                <path
                  id='パス_68574-11'
                  data-name='パス 68574'
                  d='M10.46,0a10.454,10.454,0,0,1,8.155,17L10.46,29.543,2.3,17A10.454,10.454,0,0,1,10.46,0'
                  transform='translate(0)'
                  stroke='#fff'
                  stroke-width='2'
                  fill='url(#linear-gradient)'
                />
                <path
                  id='パス_68575-11'
                  data-name='パス 68575'
                  d='M28.494,32.95a4.455,4.455,0,1,0-4.455-4.456,4.46,4.46,0,0,0,4.455,4.456'
                  transform='translate(-18.034 -18.035)'
                  fill='#fff'
                />
              </g>
              <g
                id='コンポーネント_367_61'
                data-name='コンポーネント 367 – 61'
                transform='translate(1154.058 1468.113)'
              >
                <path
                  id='パス_68574-12'
                  data-name='パス 68574'
                  d='M11.6,0a11.59,11.59,0,0,1,9.041,18.849L11.6,32.753l-9.041-13.9A11.59,11.59,0,0,1,11.6,0'
                  transform='translate(0)'
                  stroke='#fff'
                  stroke-width='2'
                  fill='url(#linear-gradient)'
                />
                <path
                  id='パス_68575-12'
                  data-name='パス 68575'
                  d='M28.978,33.918a4.939,4.939,0,1,0-4.939-4.94,4.945,4.945,0,0,0,4.939,4.94'
                  transform='translate(-17.382 -17.383)'
                  fill='#fff'
                />
              </g>
            </g>
          </g>
          <g
            id='グループ_42529'
            data-name='グループ 42529'
            transform='translate(-13.899 -88.469)'
          >
            <Link to={`${pages.halls.path}?prefecture=広島県`}>
              <g
                id='グループ_40338'
                data-name='グループ 40338'
                transform='translate(-37 60)'
              >
                <g
                  transform='matrix(1, 0, 0, 1, 966.8, 165.94)'
                  filter='url(#長方形_31733)'
                >
                  <g
                    id='長方形_31733-13'
                    data-name='長方形 31733'
                    transform='translate(9.2 328.06)'
                    fill='#fff'
                    stroke='#6cbcbe'
                    stroke-width='1'
                  >
                    <rect width='85' height='41' rx='5' stroke='none' />
                    <rect
                      x='0.5'
                      y='0.5'
                      width='84'
                      height='40'
                      rx='4.5'
                      fill='none'
                    />
                  </g>
                </g>
                <text
                  id='広島県'
                  transform='translate(988 523)'
                  fill='#333'
                  font-size='20'
                  font-family='NotoSansJP-Regular, Noto Sans JP'
                  letter-spacing='0.02em'
                >
                  <tspan x='0' y='0'>
                    広島県
                  </tspan>
                </text>
              </g>
            </Link>
            <Link to={`${pages.halls.path}?prefecture=愛媛県`}>
              <g
                id='グループ_40339'
                data-name='グループ 40339'
                transform='translate(82 217)'
              >
                <g
                  transform='matrix(1, 0, 0, 1, 847.8, 8.94)'
                  filter='url(#長方形_31733-2)'
                >
                  <g
                    id='長方形_31733-14'
                    data-name='長方形 31733'
                    transform='translate(128.2 485.06)'
                    fill='#fff'
                    stroke='#6cbcbe'
                    stroke-width='1'
                  >
                    <rect width='85' height='41' rx='5' stroke='none' />
                    <rect
                      x='0.5'
                      y='0.5'
                      width='84'
                      height='40'
                      rx='4.5'
                      fill='none'
                    />
                  </g>
                </g>
                <text
                  id='愛媛県'
                  transform='translate(988 523)'
                  fill='#333'
                  font-size='20'
                  font-family='NotoSansJP-Regular, Noto Sans JP'
                  letter-spacing='0.02em'
                >
                  <tspan x='0' y='0'>
                    愛媛県
                  </tspan>
                </text>
              </g>
            </Link>
            <Link to={`${pages.halls.path}?prefecture=岡山県`}>
              <g
                id='グループ_40340'
                data-name='グループ 40340'
                transform='translate(59 49)'
              >
                <g
                  transform='matrix(1, 0, 0, 1, 870.8, 176.94)'
                  filter='url(#長方形_31733-3)'
                >
                  <g
                    id='長方形_31733-15'
                    data-name='長方形 31733'
                    transform='translate(105.2 317.06)'
                    fill='#fff'
                    stroke='#6cbcbe'
                    stroke-width='1'
                  >
                    <rect width='85' height='41' rx='5' stroke='none' />
                    <rect
                      x='0.5'
                      y='0.5'
                      width='84'
                      height='40'
                      rx='4.5'
                      fill='none'
                    />
                  </g>
                </g>
                <text
                  id='岡山県'
                  transform='translate(988 523)'
                  fill='#333'
                  font-size='20'
                  font-family='NotoSansJP-Regular, Noto Sans JP'
                  letter-spacing='0.02em'
                >
                  <tspan x='0' y='0'>
                    岡山県
                  </tspan>
                </text>
              </g>
            </Link>
            <Link to={`${pages.halls.path}?prefecture=兵庫県`}>
              <g
                id='グループ_40341'
                data-name='グループ 40341'
                transform='translate(154 60)'
              >
                <g
                  transform='matrix(1, 0, 0, 1, 775.8, 165.94)'
                  filter='url(#長方形_31733-4)'
                >
                  <g
                    id='長方形_31733-16'
                    data-name='長方形 31733'
                    transform='translate(200.2 328.06)'
                    fill='#fff'
                    stroke='#6cbcbe'
                    stroke-width='1'
                  >
                    <rect width='85' height='41' rx='5' stroke='none' />
                    <rect
                      x='0.5'
                      y='0.5'
                      width='84'
                      height='40'
                      rx='4.5'
                      fill='none'
                    />
                  </g>
                </g>
                <text
                  id='兵庫県'
                  transform='translate(988 523)'
                  fill='#333'
                  font-size='20'
                  font-family='NotoSansJP-Regular, Noto Sans JP'
                  letter-spacing='0.02em'
                >
                  <tspan x='0' y='0'>
                    兵庫県
                  </tspan>
                </text>
              </g>
            </Link>
            <Link to={`${pages.halls.path}?prefecture=群馬県`}>
              <g
                id='グループ_40342'
                data-name='グループ 40342'
                transform='translate(257 20)'
              >
                <g
                  transform='matrix(1, 0, 0, 1, 672.8, 205.94)'
                  filter='url(#長方形_31733-5)'
                >
                  <g
                    id='長方形_31733-17'
                    data-name='長方形 31733'
                    transform='translate(303.2 288.06)'
                    fill='#fff'
                    stroke='#6cbcbe'
                    stroke-width='1'
                  >
                    <rect width='85' height='41' rx='5' stroke='none' />
                    <rect
                      x='0.5'
                      y='0.5'
                      width='84'
                      height='40'
                      rx='4.5'
                      fill='none'
                    />
                  </g>
                </g>
                <text
                  id='群馬県'
                  transform='translate(988 523)'
                  fill='#333'
                  font-size='20'
                  font-family='NotoSansJP-Regular, Noto Sans JP'
                  letter-spacing='0.02em'
                >
                  <tspan x='0' y='0'>
                    群馬県
                  </tspan>
                </text>
              </g>
            </Link>
            <Link to={`${pages.halls.path}?prefecture=東京都`}>
              <g
                id='グループ_40343'
                data-name='グループ 40343'
                transform='translate(417 112)'
              >
                <g
                  transform='matrix(1, 0, 0, 1, 512.8, 113.94)'
                  filter='url(#長方形_31733-6)'
                >
                  <g
                    id='長方形_31733-18'
                    data-name='長方形 31733'
                    transform='translate(463.2 380.06)'
                    fill='#fff'
                    stroke='#6cbcbe'
                    stroke-width='1'
                  >
                    <rect width='85' height='41' rx='5' stroke='none' />
                    <rect
                      x='0.5'
                      y='0.5'
                      width='84'
                      height='40'
                      rx='4.5'
                      fill='none'
                    />
                  </g>
                </g>
                <text
                  id='東京都'
                  transform='translate(988 523)'
                  fill='#333'
                  font-size='20'
                  font-family='NotoSansJP-Regular, Noto Sans JP'
                  letter-spacing='0.02em'
                >
                  <tspan x='0' y='0'>
                    東京都
                  </tspan>
                </text>
              </g>
            </Link>
            <Link to={`${pages.halls.path}?prefecture=茨城県`}>
              <g
                id='グループ_40344'
                data-name='グループ 40344'
                transform='translate(445 45)'
              >
                <g
                  transform='matrix(1, 0, 0, 1, 484.8, 180.94)'
                  filter='url(#長方形_31733-7)'
                >
                  <g
                    id='長方形_31733-19'
                    data-name='長方形 31733'
                    transform='translate(491.2 313.06)'
                    fill='#fff'
                    stroke='#6cbcbe'
                    stroke-width='1'
                  >
                    <rect width='85' height='41' rx='5' stroke='none' />
                    <rect
                      x='0.5'
                      y='0.5'
                      width='84'
                      height='40'
                      rx='4.5'
                      fill='none'
                    />
                  </g>
                </g>
                <text
                  id='茨城県'
                  transform='translate(988 523)'
                  fill='#333'
                  font-size='20'
                  font-family='NotoSansJP-Regular, Noto Sans JP'
                  letter-spacing='0.02em'
                >
                  <tspan x='0' y='0'>
                    茨城県
                  </tspan>
                </text>
              </g>
            </Link>
            <Link to={`${pages.halls.path}?prefecture=山形県`}>
              <g
                id='グループ_40345'
                data-name='グループ 40345'
                transform='translate(275 -65)'
              >
                <g
                  transform='matrix(1, 0, 0, 1, 654.8, 290.94)'
                  filter='url(#長方形_31733-8)'
                >
                  <g
                    id='長方形_31733-20'
                    data-name='長方形 31733'
                    transform='translate(321.2 203.06)'
                    fill='#fff'
                    stroke='#6cbcbe'
                    stroke-width='1'
                  >
                    <rect width='85' height='41' rx='5' stroke='none' />
                    <rect
                      x='0.5'
                      y='0.5'
                      width='84'
                      height='40'
                      rx='4.5'
                      fill='none'
                    />
                  </g>
                </g>
                <text
                  id='山形県'
                  transform='translate(988 523)'
                  fill='#333'
                  font-size='20'
                  font-family='NotoSansJP-Regular, Noto Sans JP'
                  letter-spacing='0.02em'
                >
                  <tspan x='0' y='0'>
                    山形県
                  </tspan>
                </text>
              </g>
            </Link>
            <Link to={`${pages.halls.path}?prefecture=青森県`}>
              <g
                id='グループ_40346'
                data-name='グループ 40346'
                transform='translate(298 -160)'
              >
                <g
                  transform='matrix(1, 0, 0, 1, 631.8, 385.94)'
                  filter='url(#長方形_31733-9)'
                >
                  <g
                    id='長方形_31733-21'
                    data-name='長方形 31733'
                    transform='translate(344.2 108.06)'
                    fill='#fff'
                    stroke='#6cbcbe'
                    stroke-width='1'
                  >
                    <rect width='85' height='41' rx='5' stroke='none' />
                    <rect
                      x='0.5'
                      y='0.5'
                      width='84'
                      height='40'
                      rx='4.5'
                      fill='none'
                    />
                  </g>
                </g>
                <text
                  id='青森県'
                  transform='translate(988 523)'
                  fill='#333'
                  font-size='20'
                  font-family='NotoSansJP-Regular, Noto Sans JP'
                  letter-spacing='0.02em'
                >
                  <tspan x='0' y='0'>
                    青森県
                  </tspan>
                </text>
              </g>
            </Link>
            <Link to={`${pages.halls.path}?prefecture=静岡県`}>
              <g
                id='グループ_41286'
                data-name='グループ 41286'
                transform='translate(293 175)'
              >
                <g
                  transform='matrix(1, 0, 0, 1, 636.8, 50.94)'
                  filter='url(#長方形_31733-10)'
                >
                  <g
                    id='長方形_31733-22'
                    data-name='長方形 31733'
                    transform='translate(339.2 443.06)'
                    fill='#fff'
                    stroke='#6cbcbe'
                    stroke-width='1'
                  >
                    <rect width='85' height='41' rx='5' stroke='none' />
                    <rect
                      x='0.5'
                      y='0.5'
                      width='84'
                      height='40'
                      rx='4.5'
                      fill='none'
                    />
                  </g>
                </g>
                <text
                  id='静岡県'
                  transform='translate(988 523)'
                  fill='#333'
                  font-size='20'
                  font-family='NotoSansJP-Regular, Noto Sans JP'
                  letter-spacing='0.02em'
                >
                  <tspan x='0' y='0'>
                    静岡県
                  </tspan>
                </text>
              </g>
            </Link>
            <Link to={`${pages.halls.path}?prefecture=栃木県`}>
              <g
                id='グループ_41287'
                data-name='グループ 41287'
                transform='translate(395 -11)'
              >
                <g
                  transform='matrix(1, 0, 0, 1, 534.8, 236.94)'
                  filter='url(#長方形_31733-11)'
                >
                  <g
                    id='長方形_31733-23'
                    data-name='長方形 31733'
                    transform='translate(441.2 257.06)'
                    fill='#fff'
                    stroke='#6cbcbe'
                    stroke-width='1'
                  >
                    <rect width='85' height='41' rx='5' stroke='none' />
                    <rect
                      x='0.5'
                      y='0.5'
                      width='84'
                      height='40'
                      rx='4.5'
                      fill='none'
                    />
                  </g>
                </g>
                <text
                  id='栃木県'
                  transform='translate(988 523)'
                  fill='#333'
                  font-size='20'
                  font-family='NotoSansJP-Regular, Noto Sans JP'
                  letter-spacing='0.02em'
                >
                  <tspan x='0' y='0'>
                    栃木県
                  </tspan>
                </text>
              </g>
            </Link>
            <Link to={`${pages.halls.path}?prefecture=埼玉県`}>
              <g
                id='グループ_41288'
                data-name='グループ 41288'
                transform='translate(280 88)'
              >
                <g
                  transform='matrix(1, 0, 0, 1, 649.8, 137.94)'
                  filter='url(#長方形_31733-12)'
                >
                  <g
                    id='長方形_31733-24'
                    data-name='長方形 31733'
                    transform='translate(326.2 356.06)'
                    fill='#fff'
                    stroke='#6cbcbe'
                    stroke-width='1'
                  >
                    <rect width='85' height='41' rx='5' stroke='none' />
                    <rect
                      x='0.5'
                      y='0.5'
                      width='84'
                      height='40'
                      rx='4.5'
                      fill='none'
                    />
                  </g>
                </g>
                <text
                  id='埼玉県'
                  transform='translate(988 523)'
                  fill='#333'
                  font-size='20'
                  font-family='NotoSansJP-Regular, Noto Sans JP'
                  letter-spacing='0.02em'
                >
                  <tspan x='0' y='0'>
                    埼玉県
                  </tspan>
                </text>
              </g>
            </Link>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default JapanMap;
